<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="tiles"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
      >
        <template slot="id" slot-scope="props">
          <span>{{ props.rowData.id }}</span>
        </template>
        <template slot="title" slot-scope="props">
          <span>{{ props.rowData.title }}</span>
        </template>
        <template slot="image" slot-scope="props">
          <span class="category-tile__img">
            <img
              v-if="props.rowData.image || props.rowData.url"
              :src="props.rowData.image || props.rowData.url"
              :alt="props.rowData.title"
            />
            <span v-else>Нет изображения</span>
          </span>
        </template>
        <template slot="status" slot-scope="props">
          <span>
            <template v-if="props.rowData.active">Вкл</template>
            <template v-else>Выкл</template>
          </span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-pencil"
            @click="update(props.rowData)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-trash"
            @click="remove(props.rowData.id)"
          />
        </template>
      </va-data-table>
    </va-card>

    <va-modal v-model="showUpdateForm" size="large" hide-default-actions>
      <category-tile-edit
        v-if="currentTile"
        :tile="currentTile"
        @hide="modalStatus"
      />
    </va-modal>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";
import CategoryTileEdit from "./category-tile-edit.vue";

export default {
  components: { CategoryTileEdit },
  props: {
    tiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showUpdateForm: false,
      currentTile: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:id",
          title: "Номер",
        },
        {
          name: "__slot:title",
          title: "Название",
        },
        {
          name: "__slot:image",
          title: "Изображение",
        },
        {
          name: "__slot:status",
          title: "Статус",
        },
        {
          name: "__slot:actions",
          title: "",
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetchCategoryTiles: "categoryTiles/getCategoryTiles",
    }),
    async remove(tileId) {
      if (confirm("Вы действительно хотите удалить?")) {
        try {
          await api.delete(`/admin/category-tiles/${tileId}`);
          await this.fetchCategoryTiles();
        } catch (error) {
          return error;
        }
      }
    },
    update(val) {
      this.currentTile = val;
      this.showUpdateForm = !this.showUpdateForm;
    },
    modalStatus() {
      this.showUpdateForm = !this.showUpdateForm;
    },
  },
};
</script>

<style scoped>
.category-tile__img img {
  display: block;
  width: 150px;
  height: 150px;
  object-fit: cover;
}
</style>
